import React, { Component, PropTypes } from 'react';
import { JsonEditor as Editor } from 'jsoneditor-react';
import 'jsoneditor-react/es/editor.min.css';
import Ajv from 'ajv';
import ace from 'brace';
import _ from 'lodash';
import 'brace/mode/json';
import 'brace/theme/github';
import './JsonCodeEditorPanel.scss';

class JsonCodeEditorPanel extends Component {
    componentDidMount() {
        this.validateData();
    }

    componentDidUpdate(prevProps) {
        if (!_.isEqual(this.props.schema, prevProps.schema)) {
            this.validateData();
        }
    }

    validateData() {
        const ajv = new Ajv({ allErrors: true, verbose: true });
        const validate = ajv.compile(this.props.schema);

        this.props.onChange({
            valid: validate(this.props.currentValue),
            value: this.props.currentValue
        });
    }

    render() {
        const ajv = new Ajv({ allErrors: true, verbose: true });
        const validate = ajv.compile(this.props.schema);

        return (
            <Editor
                theme={'brace/theme/github'}
                value={this.props.currentValue}
                schema={this.props.schema}
                onChange={changedValue => {
                    this.props.onChange({
                        valid: validate(changedValue),
                        value: changedValue ? changedValue : ''
                    });
                }}
                mode={'code'}
                ajv={ajv}
                ace={ace}
                search={true}
                navigationBar={true}
                enableTransform={false}
                statusBar={true}
                allowedModes={['code', 'tree']}
                history={true}
            />
        );
    }
}

JsonCodeEditorPanel.defaultProps = {
    onChange: () => {},
    currentValue: {},
    schema: {}
};

JsonCodeEditorPanel.propTypes = {
    onChange: PropTypes.func.isRequired,
    schema: PropTypes.object,
    currentValue: PropTypes.object
};

export default JsonCodeEditorPanel;



// WEBPACK FOOTER //
// ./src/components/widgets/CodeEditor/JsonCodeEditorPanel.js